import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Analytics = Loadable(lazy(() => import('./HotelBooking')));
const HotelList = Loadable(lazy(() => import('./HotelList')));
// const EditPipeline = Loadable(lazy(() => import('./CustomerEdit')));
// const Trans = Loadable(lazy(() => import('./CustomerTransList')));

const HotelRoutes = [
	{
		path: '/hotel/bookings',
		element: <Analytics />,
		auth: authRoles.admin,
	},
	{
		path: '/hotel/list',
		element: <HotelList />,
		auth: authRoles.admin,
	},
	// {
	// 	path: '/customer/list/trans',
	// 	element: <Trans />,
	// 	auth: authRoles.admin,
	// },
	// {
	// 	path: '/customer/list/edit',
	// 	element: <EditPipeline />,
	// 	auth: authRoles.admin,
	// },
];

export default HotelRoutes;
